export const ABOUT_HERO = {
  eyebrow: "About MedCore Research",
  title:
    "Experienced Clinical Trial Site Management. Built Around Quality, Patients and Performance.",
  description:
    "MedCore Research is a Canadian Site Management Organization supporting investigators, healthcare clinics, sponsors and CROs in the delivery of high-quality clinical trials.",
};

export const ABOUT_OVERVIEW = [
  "Our team brings hands-on clinical research experience across study start-up, site activation, regulatory and ethics submissions, essential document management, study coordination, patient recruitment, investigational product logistics and inspection readiness. This practical experience allows us to understand the operational demands placed on research sites and provide the structure, resources and oversight needed to conduct studies effectively.",
  "We work closely with community-based physicians and healthcare organizations to develop research-ready sites, strengthen their clinical trial capabilities and connect appropriate patient populations with new research opportunities. From initial site assessment through study closeout, MedCore provides consistent operational support while allowing investigators to remain focused on patient care and clinical decision-making.",
];

export const ABOUT_EXPERIENCE = {
  title: "Clinical Research Experience That Strengthens Every Site",
  paragraphs: [
    "MedCore was established by clinical research professionals with experience working across CRO, sponsor-aligned and site-facing environments. Our team understands the expectations of sponsors and CROs, as well as the day-to-day realities faced by investigators and clinic staff.",
    "This combination of operational knowledge and site-level understanding helps us anticipate challenges, reduce avoidable delays and maintain study activities in accordance with the protocol, Good Clinical Practice and applicable Canadian regulatory requirements.",
  ],
  items: [
    "Site identification, qualification and onboarding",
    "Research site development and readiness assessment",
    "Research ethics board and regulatory submissions",
    "Study start-up and site activation",
    "Investigator Site File and essential document management",
    "Site staff training and delegation oversight",
    "Patient identification, recruitment and retention support",
    "Study coordination and visit management",
    "Sponsor, CRO and vendor communication",
    "Clinical trial supply and investigational product coordination",
    "Data quality, query follow-up and protocol compliance",
    "Monitoring visit, audit and inspection readiness",
    "Study closeout and records management",
  ],
};

export const ABOUT_PARTNERSHIP = {
  title: "A Reliable Extension of Your Clinical Trial Team",
  introduction:
    "Every clinical trial site has different capabilities, resources and patient populations. MedCore does not apply a one-size-fits-all model. We assess each site individually and build an operational plan based on the protocol, enrollment requirements, investigator capacity and sponsor expectations.",
  audiences: [
    {
      icon: "stethoscope",
      title: "For Investigators and Clinics",
      description:
        "We provide the infrastructure and experienced personnel needed to participate confidently in clinical research.",
    },
    {
      icon: "handshake",
      title: "For Sponsors and CROs",
      description:
        "We provide responsive, well-organized sites supported by standardized processes, clear communication and continuous operational oversight.",
    },
  ],
  closing:
    "Our goal is to make every MedCore-supported site dependable, compliant and ready to deliver quality clinical trial data.",
};

export const ABOUT_DIRECTION = [
  {
    eyebrow: "Our Mission",
    title: "Expanding access through sustainable research programs",
    description:
      "Our mission is to expand access to clinical research by helping healthcare providers build sustainable, high-performing research programs. We are committed to supporting the safe and efficient conduct of clinical trials while protecting participants, maintaining data integrity and meeting sponsor expectations.",
  },
  {
    eyebrow: "Our Vision",
    title: "A trusted Canadian Site Management Organization",
    description:
      "Our vision is to become a trusted Canadian SMO recognized for developing capable research sites, improving access to clinical trials and delivering consistent operational quality across every study we support.",
  },
];

export const ABOUT_COMMITMENTS = [
  {
    icon: "heart-pulse",
    title: "Patient-Centred Research",
    description:
      "Patient safety, dignity and informed participation remain central to every study activity.",
  },
  {
    icon: "shield-check",
    title: "Quality and Compliance",
    description:
      "We promote disciplined documentation, protocol adherence, data integrity and ongoing inspection readiness.",
  },
  {
    icon: "gauge",
    title: "Operational Excellence",
    description:
      "We use practical processes, proactive planning and consistent oversight to keep studies moving forward.",
  },
  {
    icon: "message",
    title: "Transparent Partnership",
    description:
      "We communicate clearly with investigators, site teams, sponsors and CRO partners throughout the study lifecycle.",
  },
  {
    icon: "users",
    title: "Research Accessibility",
    description:
      "We help bring clinical research opportunities closer to patients through community-based healthcare settings.",
  },
];

export const ABOUT_FINAL = {
  title: "Moving Research Forward, Together",
  paragraphs: [
    "Successful clinical trials depend on capable investigators, supported site teams and strong collaboration among every stakeholder. MedCore Research brings these elements together to help sites perform effectively and help sponsors execute studies with greater confidence.",
    "Whether you are a healthcare provider interested in becoming a clinical trial investigator or a sponsor or CRO looking for qualified Canadian research sites, MedCore Research is ready to support your next study.",
  ],
};
